import moment from 'moment';

function now(format) {
  return moment.localeData().longDateFormat(format);
}

const userLang = navigator.language || navigator.userLanguage;
const client = () => now('L');

const date = {
  datepicker: 'DD-MMM-YYYY',
  client,
  clientLongDate: () => now('ll'),
  server: 'YYYY-MM-DD',
  ui: 'DD MMM YYYY',
  uiDateTime: () => `${now('L')} ${now('LT')}`,
  uiTime: () => now('LT'),
  uiDate: 'L',
  longDay: 'dddd',
  formats: [
    client(),
    userLang,
    'DD-MMM-YYYY',
    'YYYY-MM-DD',
    'YYYY.MM.DD.',
    'YYYY/MM/DD',
    'DD/MM/YYYY',
    'MM/DD/YYYY',
    'DD-MM-YYYY',
    'MM-DD-YYYY'
  ]
};

export default {
  date,
  convertSize: {
    bytesToKilobytes(value) {
      return (value / 1024).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  },
  customDateFormat(value, format = 'DD MMM YYYY') {
    return moment(value).format(format);
  }
};
